import {FC, useState, createContext, useContext} from 'react'
import {
    QueryState,
    QueryRequestContextProps,
    initialQueryRequest,
    WithChildren,
} from '../../../../_metronic/helpers'

const ApplicationQueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

const ApplicationQueryRequestProvider: FC<WithChildren> = ({children}) => {
    const [state, setState] = useState<QueryState>(initialQueryRequest.state)

    const updateState = (updates: Partial<QueryState>) => {        
        const updatedState = {...state, ...updates} as QueryState
        setState(updatedState)
    } 

    return (
    <ApplicationQueryRequestContext.Provider value={{state, updateState}}>
        {children}
    </ApplicationQueryRequestContext.Provider>
    )
}

const useApplicationQueryRequest = () => useContext(ApplicationQueryRequestContext)
export {ApplicationQueryRequestProvider, useApplicationQueryRequest}
